/* eslint-disable @typescript-eslint/no-explicit-any */

import { analyticsReady, domReadyLegacy, globalVarReady } from "../utils/ready";
import { KioskEvent } from "./types";
import { dispatchEvent } from "./dispatch-event";

export type Variables = {
  kiosk?: boolean;
  timeout?: number;
};

// Refer to https://drive.google.com/file/d/17dzWkV1TiuRYdpwECNHoEKUsNNpqTDo6 for documentation
export function install(variables: Variables, context: FeatureContext): void {
  domReadyLegacy(async () => {
    let vizLoader: typeof window["vizLoader"];

    try {
      vizLoader = await globalVarReady("vizLoader", { reportErrors: false });
    } catch (e) {
      return;
    }

    await analyticsReady();

    const subscribe = (eventName: string) => {
      vizLoader?.addListener(eventName, (ev: KioskEvent) => {
        dispatchEvent(ev, variables, context);
      });
    };

    if (variables.kiosk) {
      subscribe("kioskEvents");
    } else {
      subscribe("allEvents");
    }
  });
}
